// extracted by mini-css-extract-plugin
module.exports = {"vanlife-D":"D_vanlife-D__OyAWt"};